export function getElementScale(
    el: HTMLElement,
    localWidth: number = el.offsetWidth,
    localHeight: number = el.offsetHeight,
    rect: DOMRect = el.getBoundingClientRect()
): {scaleX: number; scaleY: number} {
    return {
        scaleX: rect.width ? localWidth / rect.width : 1,
        scaleY: rect.height ? localHeight / rect.height : 1,
    };
}

export function toLocalPoint(
    el: HTMLElement,
    clientX: number,
    clientY: number,
    localWidth?: number,
    localHeight?: number
): {x: number; y: number} {
    const rect = el.getBoundingClientRect();
    const {scaleX, scaleY} = getElementScale(el, localWidth, localHeight, rect);

    return {
        x: (clientX - rect.left) * scaleX,
        y: (clientY - rect.top) * scaleY,
    };
}
